const partialDateField = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsDatepicker.hbs');
const partialDisplayField = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsDisplayFields.hbs');

const general_utils = require('civicsUtils/general_utilities');

define(function (require) {

	var getDateBox = function (ele, readOnlyForm, detailOptions) {
		var format = ele.format && ele.format.toUpperCase();
		var dateOnly = format == 'DATE';
		var timeOnly = format == 'TIME';
		var pickerFormat = "datetime";
		if (dateOnly) {
			pickerFormat = "date";
		} else if (timeOnly) {
			pickerFormat = "time";
		}

		var el;
		if (readOnlyForm) {
			// readOnlyForm only shows title label with HTML description
			var v = ele.value;

			// Choose to either display date or date and time result
			if (dateOnly) {
				v = Handlebars.helpers['global:formatDate'](ele.value);
			} else if (timeOnly) {
				v = Handlebars.helpers['global:formatTime'](ele.value);
			} else {
				v = Handlebars.helpers['global:formatDateTime'](ele.value);
			}

			var customData = "specialType=\"" + ele.specialType + "\" data-dataType=\"" + ele.dataType + "\" data-format=\"" + pickerFormat + "\"";
			// Fill in data to push to partial

			var displayData = {
				id: ele.id,
				classes: ele.isVisible === false ? 'hidden date-field-container' : 'date-field-container',
				name: ele.bind ? ele.bind : ele.id,
				labelText: ele.text,
				required: ele.isRequired,
				value: v,
				formatType: pickerFormat,
				customAttr: customData,
				showValue: true,
				disabled: true,

			};

			if (ele.description) {
				displayData.tooltip = general_utils.attributeEscapeString(ele.description);
			}

			el = $(partialDisplayField($.extend({}, displayData)));
		} else {
			var classes = 'date-field-container';
			if (ele.isVisibile === false) {
				classes += " hidden";
			}
			if (pickerFormat == "datetime") {
				classes += " wider-column";
			}

			var customData = "specialType=\"" + ele.specialType + "\" data-formatType=\"date\" data-dataType=\"" + ele.dataType + "\"";
			// Building date field
			var pickerData = {
				id: ele.id,
				name: ele.bind ? ele.bind : ele.id,
				labelText: ele.text,
				defaultDate: ele.value,
				required: ele.isRequired,
				disabled: (ele.isEnabled === false),
				classes: classes,
				formatType: pickerFormat,
				customAttr: customData,
				showValue: false,
				ariaDateLabel: ele.bind ? ele.bind : ele.id + ' ' + i18n.t('CIVICS.COMMON.DATE'),
				ariaTimeLabel: ele.bind ? ele.bind : ele.id + ' ' + i18n.t('CIVICS.COMMON.TIME'),

			};
			if (ele.description) {
				pickerData.tooltip = general_utils.attributeEscapeString(ele.description);
			}

			el = $(partialDateField($.extend({}, pickerData)));
		}
		return el;
	};
	return {
		getDateBox: function (ele, readOnlyForm, detailOptions) {
			return getDateBox(ele, readOnlyForm, detailOptions);
		}
	}
});